import * as THREE from 'three'
import constants from './config/Constants'

class utils {

  // Convert light year to earth diameter (spacecast basic unit of distance).
  dis(n) {
    return n * constants.LENGTH_LY
  }

  // Convert degrees to radians.
  radians(d) {
    return d * (Math.PI/180)
  }

  // Calculate ascention in radians.
  asc(h, m, s) {
    var hDeg = h * 360 / 24
    var mDeg = m * 30 / 60
    var sDeg = s * .5 / 60
    var degrees = hDeg + mDeg + sDeg
    return this.radians(degrees)
  }

  // Calculate declination in radians.
  dec(d, m, s, isNegative = false) {
    var degrees = d + (m / 60) + (s / 3600)
    if (isNegative) {
      degrees = 90 + degrees
    } else {
      degrees = 90 - degrees
    }
    return this.radians(degrees) // convert degrees to radians
  }

  // Rotate an Object3D by a given right ascension and declination.
  rotateObject(object, asc, dec) {
    var decAxis = new THREE.Vector3().setFromCylindrical(new THREE.Cylindrical(1, asc + Math.PI / 2, 0))
    object.rotateOnAxis(decAxis, dec)
    object.rotateY(asc)
  }

  // Find next closest power of 2 of a number.
  nearestPow2(number){
    return Math.pow(2, Math.ceil(Math.log(number) / Math.log(2)))
  }

  // Return THREE.Mesh of shape THREE.SphereGeometry.
  createSphere(radius, material, segments = 32) {
    var geometry	= new THREE.SphereGeometry(radius, segments, segments)
  	return new THREE.Mesh(geometry, material)
  }
}

export default new utils()